type AppEnvironment = "development" | "production" | "staging" | "uat";

export interface RuntimeEnv {
    readonly API_URL: string;
    readonly MINIO_URL?: string;
    readonly APP_ENV: AppEnvironment;
    readonly DEBUG?: string;
}

interface AppConfigValue extends RuntimeEnv {
    readonly isDev: boolean;
    readonly isProd: boolean;
    readonly apiBase: string;
}

declare global {
    interface Window {
        __APP_CONFIG__?: Partial<RuntimeEnv>;
    }
}

const runtimeConfig = window.__APP_CONFIG__ ?? {};
const hasRuntimeConfig = Boolean(window.__APP_CONFIG__);

export const getRuntimeEnv = (): RuntimeEnv => {
    const apiUrl = hasRuntimeConfig ? runtimeConfig.API_URL : import.meta.env.VITE_API_URL;

    if (!apiUrl) {
        console.warn("Missing API_URL runtime config");
    }

    return {
        API_URL: apiUrl,
        MINIO_URL: hasRuntimeConfig ? runtimeConfig.MINIO_URL : import.meta.env.VITE_MINIO_URL,
        APP_ENV: (hasRuntimeConfig ? runtimeConfig.APP_ENV : import.meta.env.VITE_APP_ENV) || "development",
        DEBUG: hasRuntimeConfig ? runtimeConfig.DEBUG : import.meta.env.VITE_DEBUG,
    };
};

const env = getRuntimeEnv();

export const AppConfig: AppConfigValue = {
    ...env,
    isDev: env.APP_ENV === "development",
    isProd: env.APP_ENV === "production",
    apiBase: env.API_URL,
};
